import { render, staticRenderFns } from "./NewPostTeaser.vue?vue&type=template&id=7adc85c0&scoped=true&"
import script from "./NewPostTeaser.vue?vue&type=script&lang=js&"
export * from "./NewPostTeaser.vue?vue&type=script&lang=js&"
import style0 from "./NewPostTeaser.vue?vue&type=style&index=0&id=7adc85c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adc85c0",
  null
  
)

export default component.exports